import { useQuery } from '@tanstack/react-query'

import { searchPMSProperties } from 'services/pmsPropertyApi'

/**
 * Hook to search PMS properties
 * @param teamGUID - The team GUID
 * @param searchQuery - The search query
 * @param options - Additional options for the query
 */
export const usePMSPropertySearch = (
  teamGUID: string,
  searchQuery: string,
  options: any = {},
) => {
  const enabled =
    !!teamGUID && !!searchQuery?.trim() && searchQuery.trim().length >= 2

  return useQuery({
    queryKey: ['pmsProperties', teamGUID, searchQuery],
    queryFn: () => searchPMSProperties(teamGUID, searchQuery),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes
    cacheTime: 10 * 60 * 1000, // 10 minutes
    ...options,
  })
}
